import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StaffSelectorComponent } from '@principle-theorem/ng-principle-shared';
import {
  MOMENT_DATEPICKER_PROVIDERS,
  NgDialogModule,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import {
  IPractice,
  type IPracticeSetupStep,
  type IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { initMoment, type WithRef } from '@principle-theorem/shared';
import { Moment } from 'moment-timezone';

export interface IAssignStepDialogData {
  step: IPracticeSetupStep;
  practice: WithRef<IPractice>;
}

export interface IAssignStepFormData {
  assignee: WithRef<IStaffer>;
  dueDate: Moment;
}

@Component({
  selector: 'pr-assign-step-dialog',
  templateUrl: './assign-step-dialog.component.html',
  styleUrls: ['./assign-step-dialog.component.scss'],
  providers: [...MOMENT_DATEPICKER_PROVIDERS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, MatDatepickerModule, StaffSelectorComponent],
})
export class AssignStepDialogComponent {
  data = inject<IAssignStepDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(
    MatDialogRef<AssignStepDialogComponent, IAssignStepFormData>
  );

  readonly minDate = initMoment();

  form = new TypedFormGroup<IAssignStepFormData>({
    assignee: new TypedFormControl(undefined, Validators.required),
    dueDate: new TypedFormControl(undefined, Validators.required),
  });

  save(): void {
    const data = this.form.getRawValue();
    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close({
      assignee: data.assignee,
      dueDate: data.dueDate,
    });
  }
}
